(() => {
  const NEED_MAP = {
    focus: ['focus'],
    energy: ['morning-routine', 'focus'],
    meditation: ['meditation'],
    reset: ['self-care', 'stress-relief'],
    calm: ['relaxation', 'sleep'],
    connection: ['connection'],
  };

  const tokens = (value) => String(value || '').split('|').filter(Boolean);

  const bindFinder = (root) => {
    if (!root || root.dataset.ritualFinderBound === 'true') return;
    const form = root.querySelector('[data-ritual-finder-form]');
    const results = root.querySelector('[data-ritual-results]');
    const list = root.querySelector('[data-ritual-result-list]');
    const status = root.querySelector('[data-ritual-result-status]');
    const reset = root.querySelector('[data-ritual-reset]');
    const cards = Array.from(root.querySelectorAll('[data-ritual-result]'));
    if (!form || !results || !list || !status || !reset) return;

    root.dataset.ritualFinderBound = 'true';

    const checkedInputs = (name) => Array.from(form.querySelectorAll(`input[name="${name}"]:checked`));

    const update = () => {
      const timeInputs = checkedInputs('ritual-time');
      const needInputs = checkedInputs('ritual-need');
      const spaceInputs = checkedInputs('ritual-space');
      const complete = timeInputs.length > 0 && needInputs.length > 0 && spaceInputs.length > 0;
      reset.hidden = !form.querySelector('input:checked');

      if (!complete) {
        results.hidden = true;
        status.textContent = '';
        cards.forEach((card) => { card.hidden = true; });
        return;
      }

      const scored = cards.map((card) => {
        const intentions = tokens(card.dataset.intentions);
        const times = tokens(card.dataset.times);
        const spaces = tokens(card.dataset.spaces);
        const intentionMatch = needInputs.some((input) =>
          (NEED_MAP[input.value] || []).some((handle) => intentions.includes(handle))
        );
        const timeMatch = timeInputs.some((input) => times.includes(input.value));
        const spaceMatch = spaceInputs.some((input) => spaces.includes(input.value));

        return {
          card,
          score: (intentionMatch ? 5 : 0) + (timeMatch ? 3 : 0) + (spaceMatch ? 2 : 0),
          intentionMatch,
          rank: Number(card.dataset.rank) || 999,
        };
      }).sort((a, b) => b.score - a.score || a.rank - b.rank);

      const hasIntentionMatch = scored.some((item) => item.intentionMatch);
      const highestScore = scored[0]?.score || 0;
      const mode = highestScore === 0 ? 'popular' : (hasIntentionMatch ? 'matches' : 'closest');
      status.textContent = root.dataset[`${mode}Heading`] || '';

      cards.forEach((card) => { card.hidden = true; });
      const visibleResults = scored.slice(0, 3);
      visibleResults.forEach((item) => {
        item.card.hidden = false;
        list.append(item.card);
      });

      results.hidden = visibleResults.length === 0;
      if (visibleResults.length === 0) return;

      if (window.matchMedia('(max-width: 47.99rem)').matches) {
        const initialResult = visibleResults[Math.floor(visibleResults.length / 2)].card;
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            const left = initialResult.offsetLeft - (list.clientWidth - initialResult.offsetWidth) / 2;
            list.scrollTo({ left: Math.max(0, left), behavior: 'auto' });
          });
        });
      }

      results.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'nearest',
      });
    };

    form.addEventListener('change', update);
    reset.addEventListener('click', () => {
      form.reset();
      cards.sort((a, b) => Number(a.dataset.rank) - Number(b.dataset.rank)).forEach((card) => {
        card.hidden = true;
        list.append(card);
      });
      results.hidden = true;
      status.textContent = '';
      reset.hidden = true;
      form.querySelector('input')?.focus();
    });
  };

  const bindAll = (context = document) => context.querySelectorAll('[data-ritual-finder]').forEach(bindFinder);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => bindAll(), { once: true });
  } else {
    bindAll();
  }
  document.addEventListener('shopify:section:load', (event) => bindAll(event.target));
})();
